module.exports = __webpack_public_path__ + "static/media/creditScore.4dbab262.png";